const UseCases = () => {
  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center mb-12 sm:mb-16 text-accent">
          Use Cases for Real-Time Proof of Reserves
        </h2>

        <div className="grid md:grid-cols-3 gap-12 md:gap-8 max-w-6xl mx-auto">
          <div className="text-center group hover:transform hover:scale-105 transition-transform duration-300">
            <div className="w-20 h-20 sm:w-24 sm:h-24 mx-auto mb-6 bg-accent-100 rounded-full flex items-center justify-center group-hover:bg-accent-200 transition-colors">
              <svg className="w-10 h-10 sm:w-12 sm:h-12 text-accent" fill="currentColor" viewBox="0 0 20 20">
                <path d="M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z" />
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z" clipRule="evenodd" />
              </svg>
            </div>
            <h3 className="text-lg sm:text-xl font-bold mb-3 text-gray-900">
              Stablecoin Issuers &<br />Financial Institutions
            </h3>
          </div>

          <div className="text-center group hover:transform hover:scale-105 transition-transform duration-300">
            <div className="w-20 h-20 sm:w-24 sm:h-24 mx-auto mb-6 bg-accent-100 rounded-full flex items-center justify-center group-hover:bg-accent-200 transition-colors">
              <svg className="w-10 h-10 sm:w-12 sm:h-12 text-accent" fill="currentColor" viewBox="0 0 20 20">
                <path d="M3 12v3c0 1.657 3.134 3 7 3s7-1.343 7-3v-3c0 1.657-3.134 3-7 3s-7-1.343-7-3z" />
                <path d="M3 7v3c0 1.657 3.134 3 7 3s7-1.343 7-3V7c0 1.657-3.134 3-7 3S3 8.657 3 7z" />
                <path d="M17 5c0 1.657-3.134 3-7 3S3 6.657 3 5s3.134-3 7-3 7 1.343 7 3z" />
              </svg>
            </div>
            <h3 className="text-lg sm:text-xl font-bold mb-3 text-gray-900">
              Asset-Backed Tokens &<br />RWA Tokenizers
            </h3>
          </div>

          <div className="text-center group hover:transform hover:scale-105 transition-transform duration-300">
            <div className="w-20 h-20 sm:w-24 sm:h-24 mx-auto mb-6 bg-accent-100 rounded-full flex items-center justify-center group-hover:bg-accent-200 transition-colors">
              <svg className="w-10 h-10 sm:w-12 sm:h-12 text-accent" fill="currentColor" viewBox="0 0 20 20">
                <path d="M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z" />
              </svg>
            </div>
            <h3 className="text-lg sm:text-xl font-bold mb-3 text-gray-900">
              Exchange-Traded Funds &<br />Exchange-Traded Products
            </h3>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UseCases;
